import { Box, Button, Stack, Text } from "@chakra-ui/react";
import { ApiErrorProvider } from "@raiden/library/components/ReactHookForm/ApiError";
import useAuthAs from "@raiden/library/hooks/auth/as";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import { FormattedMessage, useIntl } from "react-intl";
import SWRHandler from "../../../components/SWR/SWRHandler";
import StepBottomBar from "../StepBottomBar";
import StepLayout from "../StepLayout";
import Form from "./Form";
import Handler from "./Handler";

/**
 * @typedef {Object} Props
 * @property {() => void} nextStep
 *
 * @param {Props} props
 */
function StepInformation({ nextStep }) {
  const intl = useIntl();

  const { user } = useAuthAs();

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Customer").Customer>} */
  const { swrResponse: swrResponseCustomer } = useApi(
    user
      ? generateApiUri({
          id: "@customers.view",
          parameters: {
            customerId: user?.id,
          },
          query: {
            fields: ["customer.default_address"],
          },
        })
      : null,
  );

  return (
    <StepLayout
      title={intl.formatMessage({
        defaultMessage: "Informations personnelles",
      })}>
      <Box mt="1rem">
        <Text colorScheme="gray" px="1rem">
          <FormattedMessage defaultMessage="Complétez les informations concernant votre compte." />
        </Text>

        <SWRHandler
          swrResponse={swrResponseCustomer}
          wrapper={(children) => <Box p="1rem">{children}</Box>}>
          {(response) => (
            <ApiErrorProvider>
              <Handler
                customer={response.data}
                onSuccess={nextStep}
                render={({ form, isLoading }) => (
                  <Box mt="1rem">
                    <Stack spacing="1rem" px="1rem" pb="1rem">
                      <Form />
                    </Stack>

                    <StepBottomBar>
                      <Button
                        type="submit"
                        isLoading={isLoading}
                        colorScheme="brandSecondary">
                        <FormattedMessage defaultMessage="Enregistrer" />
                      </Button>
                    </StepBottomBar>
                  </Box>
                )}
              />
            </ApiErrorProvider>
          )}
        </SWRHandler>
      </Box>
    </StepLayout>
  );
}

export default StepInformation;
